<template>
  <base-slide-over ref="slideOver" title="Onboarding Documents" size="lg">
    <base-content>
      <h3 class="tw-text-lg">Video File</h3>
      <div v-if="isOnboardingDocumentLoading === true">
        <base-skeleton-loader class="tw-h-8 tw-w-24" />
      </div>
      <div v-else>
        <div v-if="currentOnboardingDocument !== null">
          <video :src="currentOnboardingDocument.downloadUrl" controls v-if="['mp4', 'm4v'].includes(currentOnboardingDocument.extension)" class="tw-w-full" ref="video">
            <source :src="currentOnboardingDocument.downloadUrl" :type="`video/${currentOnboardingDocument.extension}`" />
          </video>
        </div>
        <div v-else class="tw-border tw-rounded-lg tw-my-3 tw-py-3">
          <div class="tw-text-center tw-text-gray-500 tw-italic">-- No file --</div>
        </div>
      </div>
      <div></div>
      <base-form ref="onboardingForm" class="tw-mt-3">
        <FormulateForm name="fileInputForm">
          <FormulateInput type="file" name="file" label="Upload new video" help="MP4, M4V" validation="required|mime:video/mp4,video/x-m4v" v-model="document" />
        </FormulateForm>
      </base-form>
      <h3 class="tw-text-lg tw-mt-6">Thumbnail Image</h3>
      <div v-if="isThumbnailLoading === true">
        <base-skeleton-loader class="tw-h-8 tw-w-24" />
      </div>
      <div v-else>
        <div v-if="currentThumbnailDocument !== null" class="tw-border tw-rounded-lg">
          <img class="tw-rounded-t-md" :src="currentThumbnailDocument.downloadUrl" :style="{ height: '6rem', width: 'auto' }" style="object-fit:cover" />
        </div>
        <div v-else class="tw-border tw-rounded-lg tw-my-3 tw-py-3">
          <div class="tw-text-center tw-text-gray-500 tw-italic">-- No file --</div>
        </div>
      </div>
      <div></div>
      <base-form ref="thumbnailForm" class="tw-mt-3">
        <FormulateForm name="imageInputForm">
          <FormulateInput type="file" name="file" label="Upload new thumbnail image" help="PNG, JPG" validation="required|mime:image/jpeg,image/png" v-model="imageFile" />
        </FormulateForm>
        <div class="tw-text-sm tw-mt-4">* Uploading a new document will overwrite and delete any existing document attached to this program from the system.</div>
        <inline-error class="tw-my-3" id="upload-onboarding-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
      </base-form>
    </base-content>
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="hide()" class="tw-mr-3">Cancel</base-button>
        <base-button @click="saveOnboarding()" :disabled="hasUploadedOnboardingDocument === false && hasUploadedThumbnail === false" :loading="isSaving">Save</base-button>
      </div>
    </template>
  </base-slide-over>
</template>
<script>
import InlineError from "@/components/InlineError";

export default {
  name: "UploadOnboardingDocuments",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      businessProgramId: null,
      currentOnboardingDocument: null,
      currentThumbnailDocument: null,
      isOnboardingDocumentLoading: false,
      isThumbnailLoading: false,
      isSaving: false,
      document: null,
      imageFile: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    hasUploadedOnboardingDocument() {
      if (this.document === null) return false;
      else {
        if (this.document.results === false) return false;
        else if (this.document.results.length > 0) return true;
        else return false;
      }
    },
    hasUploadedThumbnail() {
      if (this.imageFile === null) return false;
      else {
        if (this.imageFile.results === false) return false;
        else if (this.imageFile.results.length > 0) return true;
        else return false;
      }
    },
  },
  methods: {
    saveOnboarding() {
      this.isSaving = true;

      let documentId = null;
      if (this.document) documentId = this.document.files[0].path.documentId;

      let imageDocumentId = null;
      if (this.imageFile) imageDocumentId = this.imageFile.files[0].path.documentId;

      this.$axios
        .post(`/businesses/${this.businessId}/programs/${this.businessProgramId}/onboarding`, {
          onboardingDocumentId: documentId,
          onboardingThumbnailId: imageDocumentId,
        })
        .then(() => {
          this.$emit("saved");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Onboarding Documents Saved", message: `Documents were saved successfully.` });
          this.reset();
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Failed to save documents`;
          this.errorMessage = `These documents were not ablt to be saved. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    getOnboardingDocument(documentId) {
      this.isOnboardingDocumentLoading = true;

      this.$axios
        .get(`/documents/${documentId}`)
        .then((res) => {
          this.currentOnboardingDocument = res.data;
        })
        .finally(() => {
          this.isOnboardingDocumentLoading = false;
        });
    },
    getThumbnailDocument(documentId) {
      this.isThumbnailLoading = true;

      this.$axios
        .get(`/documents/${documentId}`)
        .then((res) => {
          this.currentThumbnailDocument = res.data;
        })
        .finally(() => {
          this.isThumbnailLoading = false;
        });
    },
    reset() {
      this.businessProgramId = null;
      this.currentOnboardingDocument = null;
      this.currentThumbnailDocument = null;
      this.document = null;
      this.imageFile = null;
    },
    async show(program) {
      this.reset();
      this.businessProgramId = program.businessProgramId;
      if (program.onboardingDocumentId !== null) this.getOnboardingDocument(program.onboardingDocumentId);
      if (program.onboardingThumbnailId !== null) this.getThumbnailDocument(program.onboardingThumbnailId);
      this.$refs.slideOver.show();
    },
    hide() {
      this.$refs.slideOver.hide();
      this.reset();
    },
  },
};
</script>
